import { DatePicker } from "@/components/ui/date-picker";
import { OrganizationSettings } from "@/libs/api/types";
import { useDriver } from "@/libs/auth/data/driver";
import { useSettings } from "@/libs/settings/hooks/useSettings";
import { ProfileSidebar } from "@/libs/tours/components/ProfileSidebar";
import { TourList } from "@/libs/tours/components/TourList";
import { useTours } from "@/libs/tours/hooks/useTours";

export function TourOverviewPage() {
  const { driver } = useDriver();

  const { tours, loading, error, selectedDate, handleLoadTours } = useTours(
    driver?.id,
  );

  return (
    <div className="h-screen bg-white flex flex-col">
      <div className="bg-white flex items-center justify-between p-4 pt-safe">
        <ProfileSidebar name={driver?.name} />

        <DatePicker selected={selectedDate} onChange={handleLoadTours} />
      </div>

      <div className="flex-1 overflow-y-auto bg-slate-100">
        <TourList
          tours={tours}
          isLoading={loading}
          onLoadMore={handleLoadTours}
          error={error}
        />
      </div>
    </div>
  );
}
